import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=33766d7a"
import script from "./invoice-list.vue?vue&type=script&lang=js"
export * from "./invoice-list.vue?vue&type=script&lang=js"
import style0 from "./invoice-list.vue?vue&type=style&index=0&id=33766d7a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports